var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8598 1.75823C16.0473 1.94573 16.141 2.17341 16.141 2.44127C16.141 2.70912 16.0473 2.9368 15.8598 3.1243L8.58747 10.3966L7.2214 11.7627C7.0339 11.9502 6.80622 12.0439 6.53837 12.0439C6.27051 12.0439 6.04283 11.9502 5.85533 11.7627L4.48926 10.3966L0.853097 6.76046C0.665597 6.57296 0.571847 6.34528 0.571847 6.07743C0.571847 5.80957 0.665597 5.58189 0.853097 5.39439L2.21917 4.02832C2.40667 3.84082 2.63435 3.74707 2.9022 3.74707C3.17006 3.74707 3.39774 3.84082 3.58524 4.02832L6.53837 6.99149L13.1277 0.392159C13.3152 0.204659 13.5428 0.110909 13.8107 0.110909C14.0785 0.110909 14.3062 0.204659 14.4937 0.392159L15.8598 1.75823Z",
    fill: "#04C8B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.a0a59878079c73b53448dce9eb5aecad.svg";
export { ForwardRef as ReactComponent };